var _mask, _ellipse, _path, _mask2, _ellipse2, _path2, _mask3, _ellipse3, _path3, _mask4, _ellipse4, _path4, _mask5, _ellipse5, _path5, _mask6, _ellipse6, _path6, _mask7, _ellipse7, _path7, _mask8, _ellipse8, _path8, _mask9, _ellipse9, _path9, _mask10, _ellipse10, _path10, _mask11, _ellipse11, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _mask12, _ellipse12, _path21, _mask13, _ellipse13, _path22, _mask14, _ellipse14, _path23, _mask15, _ellipse15, _path24, _mask16, _ellipse16, _path25, _mask17, _ellipse17, _path26, _mask18, _ellipse18, _path27, _mask19, _ellipse19, _path28, _mask20, _ellipse20, _path29, _mask21, _ellipse21, _path30, _mask22, _ellipse22, _path31;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconRocket2 = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 80,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.539,
    cy: 8.38171,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.539,
    cy: 8.38171,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.141 8.38171H135.503C135.503 8.38212 135.503 8.38081 135.504 8.37832C135.504 8.37593 135.505 8.37343 135.506 8.37108C135.508 8.3666 135.51 8.36379 135.512 8.36196C135.514 8.36012 135.517 8.35737 135.523 8.35487C135.53 8.35191 135.537 8.35102 135.539 8.35102V9.98901V11.627C137.334 11.627 138.779 10.1688 138.779 8.38171H137.141ZM135.539 9.98901V8.35102C135.542 8.35102 135.549 8.35191 135.556 8.35487C135.562 8.35737 135.565 8.36012 135.567 8.36196C135.569 8.36379 135.571 8.3666 135.573 8.37108C135.574 8.37343 135.575 8.37593 135.575 8.37832C135.576 8.38081 135.575 8.38212 135.575 8.38171H133.938H132.3C132.3 10.1688 133.745 11.627 135.539 11.627V9.98901ZM133.938 8.38171H135.575C135.575 8.3813 135.576 8.38262 135.575 8.38511C135.575 8.3875 135.574 8.39 135.573 8.39235C135.571 8.39683 135.569 8.39964 135.567 8.40147C135.565 8.4033 135.562 8.40606 135.556 8.40855C135.549 8.41152 135.542 8.41241 135.539 8.41241V6.77441V5.13642C133.745 5.13642 132.3 6.59458 132.3 8.38171H133.938ZM135.539 6.77441V8.41241C135.537 8.41241 135.53 8.41152 135.523 8.40855C135.517 8.40606 135.514 8.4033 135.512 8.40147C135.51 8.39964 135.508 8.39683 135.506 8.39235C135.505 8.39 135.504 8.3875 135.504 8.38511C135.503 8.38262 135.503 8.3813 135.503 8.38171H137.141H138.779C138.779 6.59458 137.334 5.13642 135.539 5.13642V6.77441Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_13398_258124)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.602,
    cy: 39.1073,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.602,
    cy: 39.1073,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.204 39.1073H112.566C112.566 39.1077 112.566 39.1064 112.566 39.1039C112.567 39.1015 112.568 39.099 112.569 39.0967C112.57 39.0922 112.573 39.0894 112.574 39.0875C112.576 39.0857 112.58 39.083 112.586 39.0805C112.593 39.0775 112.599 39.0766 112.602 39.0766V40.7146V42.3526C114.396 42.3526 115.842 40.8944 115.842 39.1073H114.204ZM112.602 40.7146V39.0766C112.605 39.0766 112.611 39.0775 112.618 39.0805C112.624 39.083 112.628 39.0857 112.629 39.0875C112.631 39.0894 112.633 39.0922 112.635 39.0967C112.636 39.099 112.637 39.1015 112.638 39.1039C112.638 39.1064 112.638 39.1077 112.638 39.1073H111H109.362C109.362 40.8944 110.807 42.3526 112.602 42.3526V40.7146ZM111 39.1073H112.638C112.638 39.1069 112.638 39.1082 112.638 39.1107C112.637 39.1131 112.636 39.1156 112.635 39.1179C112.633 39.1224 112.631 39.1252 112.629 39.1271C112.628 39.1289 112.624 39.1316 112.618 39.1341C112.611 39.1371 112.605 39.138 112.602 39.138V37.5V35.862C110.807 35.862 109.362 37.3202 109.362 39.1073H111ZM112.602 37.5V39.138C112.599 39.138 112.593 39.1371 112.586 39.1341C112.58 39.1316 112.576 39.1289 112.574 39.1271C112.573 39.1252 112.57 39.1224 112.569 39.1179C112.568 39.1156 112.567 39.1131 112.566 39.1107C112.566 39.1082 112.566 39.1069 112.566 39.1073H114.204H115.842C115.842 37.3202 114.396 35.862 112.602 35.862V37.5Z",
    fill: "currentColor",
    mask: "url(#path-3-inside-2_13398_258124)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.602,
    cy: 76.1073,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.602,
    cy: 76.1073,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.204 76.1073H153.566C153.566 76.1077 153.566 76.1064 153.566 76.1039C153.567 76.1015 153.568 76.099 153.569 76.0967C153.57 76.0922 153.573 76.0894 153.574 76.0875C153.576 76.0857 153.58 76.083 153.586 76.0805C153.593 76.0775 153.599 76.0766 153.602 76.0766V77.7146V79.3526C155.396 79.3526 156.842 77.8944 156.842 76.1073H155.204ZM153.602 77.7146V76.0766C153.605 76.0766 153.611 76.0775 153.618 76.0805C153.624 76.083 153.628 76.0857 153.629 76.0875C153.631 76.0894 153.633 76.0922 153.635 76.0967C153.636 76.099 153.637 76.1015 153.638 76.1039C153.638 76.1064 153.638 76.1077 153.638 76.1073H152H150.362C150.362 77.8944 151.807 79.3526 153.602 79.3526V77.7146ZM152 76.1073H153.638C153.638 76.1069 153.638 76.1082 153.638 76.1107C153.637 76.1131 153.636 76.1156 153.635 76.1179C153.633 76.1224 153.631 76.1252 153.629 76.1271C153.628 76.1289 153.624 76.1316 153.618 76.1341C153.611 76.1371 153.605 76.138 153.602 76.138V74.5V72.862C151.807 72.862 150.362 74.3202 150.362 76.1073H152ZM153.602 74.5V76.138C153.599 76.138 153.593 76.1371 153.586 76.1341C153.58 76.1316 153.576 76.1289 153.574 76.1271C153.573 76.1252 153.57 76.1224 153.569 76.1179C153.568 76.1156 153.567 76.1131 153.566 76.1107C153.566 76.1082 153.566 76.1069 153.566 76.1073H155.204H156.842C156.842 74.3202 155.396 72.862 153.602 72.862V74.5Z",
    fill: "currentColor",
    mask: "url(#path-5-inside-3_13398_258124)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.053,
    cy: 30.6704,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.053,
    cy: 30.6704,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160 30.6704H158.362C158.362 30.296 158.666 29.983 159.053 29.983V31.621V33.259C160.486 33.259 161.638 32.0949 161.638 30.6704H160ZM159.053 31.621V29.983C159.439 29.983 159.743 30.296 159.743 30.6704H158.105H156.467C156.467 32.0949 157.62 33.259 159.053 33.259V31.621ZM158.105 30.6704H159.743C159.743 31.0448 159.439 31.3577 159.053 31.3577V29.7197V28.0817C157.62 28.0817 156.467 29.2459 156.467 30.6704H158.105ZM159.053 29.7197V31.3577C158.666 31.3577 158.362 31.0448 158.362 30.6704H160H161.638C161.638 29.2459 160.486 28.0817 159.053 28.0817V29.7197Z",
    fill: "currentColor",
    mask: "url(#path-7-inside-4_13398_258124)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.947465,
    cy: 19.1196,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.947465,
    cy: 19.1196,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89493 19.1196H0.256935C0.256935 18.7452 0.560907 18.4323 0.947465 18.4323V20.0703V21.7083C2.38056 21.7083 3.53293 20.5441 3.53293 19.1196H1.89493ZM0.947465 20.0703V18.4323C1.33402 18.4323 1.638 18.7452 1.638 19.1196H0H-1.638C-1.638 20.5441 -0.485634 21.7083 0.947465 21.7083V20.0703ZM0 19.1196H1.638C1.638 19.494 1.33402 19.8069 0.947465 19.8069V18.1689V16.531C-0.485634 16.531 -1.638 17.6951 -1.638 19.1196H0ZM0.947465 18.1689V19.8069C0.560907 19.8069 0.256935 19.494 0.256935 19.1196H1.89493H3.53293C3.53293 17.6951 2.38056 16.531 0.947465 16.531V18.1689Z",
    fill: "currentColor",
    mask: "url(#path-9-inside-5_13398_258124)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-6_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9025,
    cy: 55.5434,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9025,
    cy: 55.5434,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.85 55.5434H21.212C21.212 55.169 21.516 54.8561 21.9025 54.8561V56.4941V58.1321C23.3356 58.1321 24.488 56.9679 24.488 55.5434H22.85ZM21.9025 56.4941V54.8561C22.2891 54.8561 22.5931 55.169 22.5931 55.5434H20.9551H19.3171C19.3171 56.9679 20.4694 58.1321 21.9025 58.1321V56.4941ZM20.9551 55.5434H22.5931C22.5931 55.9178 22.2891 56.2308 21.9025 56.2308V54.5928V52.9548C20.4694 52.9548 19.3171 54.119 19.3171 55.5434H20.9551ZM21.9025 54.5928V56.2308C21.516 56.2308 21.212 55.9178 21.212 55.5434H22.85H24.488C24.488 54.119 23.3356 52.9548 21.9025 52.9548V54.5928Z",
    fill: "currentColor",
    mask: "url(#path-11-inside-6_13398_258124)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-7_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.188,
    cy: 34.8906,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.188,
    cy: 34.8906,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.135 34.8906H130.497C130.497 34.5162 130.801 34.2033 131.188 34.2033V35.8413V37.4792C132.621 37.4792 133.773 36.3151 133.773 34.8906H132.135ZM131.188 35.8413V34.2033C131.574 34.2033 131.878 34.5162 131.878 34.8906H130.24H128.602C128.602 36.3151 129.755 37.4792 131.188 37.4792V35.8413ZM130.24 34.8906H131.878C131.878 35.265 131.574 35.5779 131.188 35.5779V33.9399V32.3019C129.755 32.3019 128.602 33.4661 128.602 34.8906H130.24ZM131.188 33.9399V35.5779C130.801 35.5779 130.497 35.265 130.497 34.8906H132.135H133.773C133.773 33.4661 132.621 32.3019 131.188 32.3019V33.9399Z",
    fill: "currentColor",
    mask: "url(#path-13-inside-7_13398_258124)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-8_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.947,
    cy: 16.4507,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.947,
    cy: 16.4507,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.895 16.4507H103.257C103.257 16.0762 103.561 15.7633 103.947 15.7633V17.4013V19.0393C105.381 19.0393 106.533 17.8751 106.533 16.4507H104.895ZM103.947 17.4013V15.7633C104.334 15.7633 104.638 16.0762 104.638 16.4507H103H101.362C101.362 17.8751 102.514 19.0393 103.947 19.0393V17.4013ZM103 16.4507H104.638C104.638 16.8251 104.334 17.138 103.947 17.138V15.5V13.862C102.514 13.862 101.362 15.0262 101.362 16.4507H103ZM103.947 15.5V17.138C103.561 17.138 103.257 16.8251 103.257 16.4507H104.895H106.533C106.533 15.0262 105.381 13.862 103.947 13.862V15.5Z",
    fill: "currentColor",
    mask: "url(#path-15-inside-8_13398_258124)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-9_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.1955,
    cy: 2.45066,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.1955,
    cy: 2.45066,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.143 2.45066H33.505C33.505 2.07625 33.809 1.76332 34.1955 1.76332V3.40131V5.03931C35.6286 5.03931 36.781 3.87513 36.781 2.45066H35.143ZM34.1955 3.40131V1.76332C34.5821 1.76332 34.886 2.07625 34.886 2.45066H33.248H31.6101C31.6101 3.87513 32.7624 5.03931 34.1955 5.03931V3.40131ZM33.248 2.45066H34.886C34.886 2.82507 34.5821 3.138 34.1955 3.138V1.5V-0.137995C32.7624 -0.137995 31.6101 1.02618 31.6101 2.45066H33.248ZM34.1955 1.5V3.138C33.809 3.138 33.505 2.82507 33.505 2.45066H35.143H36.781C36.781 1.02618 35.6286 -0.137995 34.1955 -0.137995V1.5Z",
    fill: "currentColor",
    mask: "url(#path-17-inside-9_13398_258124)"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-10_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26108,
    cy: 66.2455,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26108,
    cy: 66.2455,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86299 66.2455H2.22499C2.22499 66.2459 2.22497 66.2446 2.22548 66.2421C2.22597 66.2397 2.22674 66.2372 2.22773 66.2348C2.22962 66.2304 2.23179 66.2276 2.23362 66.2257C2.23544 66.2239 2.23883 66.2211 2.24471 66.2186C2.2517 66.2157 2.25833 66.2148 2.26108 66.2148V67.8528V69.4908C4.05562 69.4908 5.50098 68.0326 5.50098 66.2455H3.86299ZM2.26108 67.8528V66.2148C2.26384 66.2148 2.27047 66.2157 2.27746 66.2186C2.28333 66.2211 2.28672 66.2239 2.28855 66.2257C2.29038 66.2276 2.29255 66.2304 2.29443 66.2348C2.29542 66.2372 2.29619 66.2397 2.29668 66.2421C2.29719 66.2446 2.29717 66.2459 2.29717 66.2455H0.65918H-0.978815C-0.978815 68.0326 0.466547 69.4908 2.26108 69.4908V67.8528ZM0.65918 66.2455H2.29717C2.29717 66.2451 2.29719 66.2464 2.29668 66.2489C2.29619 66.2513 2.29542 66.2538 2.29443 66.2561C2.29255 66.2606 2.29038 66.2634 2.28855 66.2652C2.28672 66.2671 2.28333 66.2698 2.27746 66.2723C2.27047 66.2753 2.26384 66.2762 2.26108 66.2762V64.6382V63.0002C0.466547 63.0002 -0.978815 64.4584 -0.978815 66.2455H0.65918ZM2.26108 64.6382V66.2762C2.25833 66.2762 2.2517 66.2753 2.24471 66.2723C2.23883 66.2698 2.23544 66.2671 2.23362 66.2652C2.23179 66.2634 2.22962 66.2606 2.22773 66.2561C2.22674 66.2538 2.22597 66.2513 2.22548 66.2489C2.22497 66.2464 2.22499 66.2451 2.22499 66.2455H3.86299H5.50098C5.50098 64.4584 4.05562 63.0002 2.26108 63.0002V64.6382Z",
    fill: "currentColor",
    mask: "url(#path-19-inside-10_13398_258124)"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-21-inside-11_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.6019,
    cy: 61.1073,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.6019,
    cy: 61.1073,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2038 61.1073H44.5658C44.5658 61.1077 44.5658 61.1064 44.5663 61.1039C44.5668 61.1015 44.5676 61.099 44.5686 61.0967C44.5704 61.0922 44.5726 61.0894 44.5744 61.0875C44.5763 61.0857 44.5797 61.083 44.5855 61.0805C44.5925 61.0775 44.5991 61.0766 44.6019 61.0766V62.7146V64.3526C46.3964 64.3526 47.8418 62.8944 47.8418 61.1073H46.2038ZM44.6019 62.7146V61.0766C44.6047 61.0766 44.6113 61.0775 44.6183 61.0805C44.6242 61.083 44.6275 61.0857 44.6294 61.0875C44.6312 61.0894 44.6334 61.0922 44.6353 61.0967C44.6362 61.099 44.637 61.1015 44.6375 61.1039C44.638 61.1064 44.638 61.1077 44.638 61.1073H43H41.362C41.362 62.8944 42.8074 64.3526 44.6019 64.3526V62.7146ZM43 61.1073H44.638C44.638 61.1069 44.638 61.1082 44.6375 61.1107C44.637 61.1131 44.6362 61.1156 44.6353 61.1179C44.6334 61.1224 44.6312 61.1252 44.6294 61.1271C44.6275 61.1289 44.6242 61.1316 44.6183 61.1341C44.6113 61.1371 44.6047 61.138 44.6019 61.138V59.5V57.862C42.8074 57.862 41.362 59.3202 41.362 61.1073H43ZM44.6019 59.5V61.138C44.5991 61.138 44.5925 61.1371 44.5855 61.1341C44.5797 61.1316 44.5763 61.1289 44.5744 61.1271C44.5726 61.1252 44.5704 61.1224 44.5686 61.1179C44.5676 61.1156 44.5668 61.1131 44.5663 61.1107C44.5658 61.1082 44.5658 61.1069 44.5658 61.1073H46.2038H47.8418C47.8418 59.3202 46.3964 57.862 44.6019 57.862V59.5Z",
    fill: "currentColor",
    mask: "url(#path-21-inside-11_13398_258124)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.085 26.8813C24.7533 26.8813 26.1102 28.2387 26.1104 29.9194C26.1104 31.6003 24.7534 32.9585 23.085 32.9585C21.4165 32.9585 20.0596 31.6003 20.0596 29.9194C20.0597 28.2387 21.4166 26.8814 23.085 26.8813Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.638
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M131.426 59.6709C132.414 59.6711 133.22 60.4755 133.22 61.4736C133.22 62.4716 132.414 63.2762 131.426 63.2764C130.438 63.2764 129.632 62.4717 129.632 61.4736C129.632 60.4754 130.438 59.6709 131.426 59.6709Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.638
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4746 71.5208C100.752 71.5208 103.052 69.5236 103.052 64.7041C103.052 69.5236 105.337 71.5208 110.63 71.5208C105.337 71.5208 103.052 73.5759 103.052 78.3375C103.052 73.5759 100.752 71.5208 95.4746 71.5208Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9846 42.8697L77.7169 54.6478L68.6755 49.6164L72.6244 32.6526C73.7505 27.8152 77.2692 23.8193 82.038 21.9621L92.2179 17.9976C93.1621 17.6298 94.2136 18.215 94.3553 19.187L95.8831 29.6666C96.5988 34.5759 94.7677 39.511 90.9846 42.8697Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7598 56.1519C62.1497 60.5091 65.3654 65.2035 65.3654 65.2035C65.3654 65.2035 71.1911 65.5405 73.8011 61.1832",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1569 37.9251C59.9831 38.9693 59.2838 50.1995 59.2838 50.1995L68.6748 49.6158",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M87.955 47.273C92.6036 57.1221 82.8629 63.321 82.8629 63.321L78.6919 55.1901",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0262 39.0599C78.5294 37.6705 77.674 34.5934 79.1156 32.1869C80.557 29.7804 83.7495 28.9559 86.2463 30.3453C88.743 31.7347 89.5984 34.8118 88.1569 37.2182C86.7154 39.6248 83.523 40.4493 81.0262 39.0599Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0592 11.7306C53.622 11.6909 55.5938 9.82325 55.5519 5.35844C55.5938 9.82325 57.5864 11.6563 62.163 11.6164C57.5864 11.6563 55.629 13.5774 55.6703 17.9886C55.629 13.5774 53.622 11.6909 49.0592 11.7306Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 80,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 80",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.539,
    cy: 8.38171,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.539,
    cy: 8.38171,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M137.141 8.38171H135.503C135.503 8.38212 135.503 8.38081 135.504 8.37832C135.504 8.37593 135.505 8.37343 135.506 8.37108C135.508 8.3666 135.51 8.36379 135.512 8.36196C135.514 8.36012 135.517 8.35737 135.523 8.35487C135.53 8.35191 135.537 8.35102 135.539 8.35102V9.98901V11.627C137.334 11.627 138.779 10.1688 138.779 8.38171H137.141ZM135.539 9.98901V8.35102C135.542 8.35102 135.549 8.35191 135.556 8.35487C135.562 8.35737 135.565 8.36012 135.567 8.36196C135.569 8.36379 135.571 8.3666 135.573 8.37108C135.574 8.37343 135.575 8.37593 135.575 8.37832C135.576 8.38081 135.575 8.38212 135.575 8.38171H133.938H132.3C132.3 10.1688 133.745 11.627 135.539 11.627V9.98901ZM133.938 8.38171H135.575C135.575 8.3813 135.576 8.38262 135.575 8.38511C135.575 8.3875 135.574 8.39 135.573 8.39235C135.571 8.39683 135.569 8.39964 135.567 8.40147C135.565 8.4033 135.562 8.40606 135.556 8.40855C135.549 8.41152 135.542 8.41241 135.539 8.41241V6.77441V5.13642C133.745 5.13642 132.3 6.59458 132.3 8.38171H133.938ZM135.539 6.77441V8.41241C135.537 8.41241 135.53 8.41152 135.523 8.40855C135.517 8.40606 135.514 8.4033 135.512 8.40147C135.51 8.39964 135.508 8.39683 135.506 8.39235C135.505 8.39 135.504 8.3875 135.504 8.38511C135.503 8.38262 135.503 8.3813 135.503 8.38171H137.141H138.779C138.779 6.59458 137.334 5.13642 135.539 5.13642V6.77441Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_13398_258124)"
  })), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.602,
    cy: 39.1073,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.602,
    cy: 39.1073,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M114.204 39.1073H112.566C112.566 39.1077 112.566 39.1064 112.566 39.1039C112.567 39.1015 112.568 39.099 112.569 39.0967C112.57 39.0922 112.573 39.0894 112.574 39.0875C112.576 39.0857 112.58 39.083 112.586 39.0805C112.593 39.0775 112.599 39.0766 112.602 39.0766V40.7146V42.3526C114.396 42.3526 115.842 40.8944 115.842 39.1073H114.204ZM112.602 40.7146V39.0766C112.605 39.0766 112.611 39.0775 112.618 39.0805C112.624 39.083 112.628 39.0857 112.629 39.0875C112.631 39.0894 112.633 39.0922 112.635 39.0967C112.636 39.099 112.637 39.1015 112.638 39.1039C112.638 39.1064 112.638 39.1077 112.638 39.1073H111H109.362C109.362 40.8944 110.807 42.3526 112.602 42.3526V40.7146ZM111 39.1073H112.638C112.638 39.1069 112.638 39.1082 112.638 39.1107C112.637 39.1131 112.636 39.1156 112.635 39.1179C112.633 39.1224 112.631 39.1252 112.629 39.1271C112.628 39.1289 112.624 39.1316 112.618 39.1341C112.611 39.1371 112.605 39.138 112.602 39.138V37.5V35.862C110.807 35.862 109.362 37.3202 109.362 39.1073H111ZM112.602 37.5V39.138C112.599 39.138 112.593 39.1371 112.586 39.1341C112.58 39.1316 112.576 39.1289 112.574 39.1271C112.573 39.1252 112.57 39.1224 112.569 39.1179C112.568 39.1156 112.567 39.1131 112.566 39.1107C112.566 39.1082 112.566 39.1069 112.566 39.1073H114.204H115.842C115.842 37.3202 114.396 35.862 112.602 35.862V37.5Z",
    fill: "currentColor",
    mask: "url(#path-3-inside-2_13398_258124)"
  })), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.602,
    cy: 76.1073,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.602,
    cy: 76.1073,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M155.204 76.1073H153.566C153.566 76.1077 153.566 76.1064 153.566 76.1039C153.567 76.1015 153.568 76.099 153.569 76.0967C153.57 76.0922 153.573 76.0894 153.574 76.0875C153.576 76.0857 153.58 76.083 153.586 76.0805C153.593 76.0775 153.599 76.0766 153.602 76.0766V77.7146V79.3526C155.396 79.3526 156.842 77.8944 156.842 76.1073H155.204ZM153.602 77.7146V76.0766C153.605 76.0766 153.611 76.0775 153.618 76.0805C153.624 76.083 153.628 76.0857 153.629 76.0875C153.631 76.0894 153.633 76.0922 153.635 76.0967C153.636 76.099 153.637 76.1015 153.638 76.1039C153.638 76.1064 153.638 76.1077 153.638 76.1073H152H150.362C150.362 77.8944 151.807 79.3526 153.602 79.3526V77.7146ZM152 76.1073H153.638C153.638 76.1069 153.638 76.1082 153.638 76.1107C153.637 76.1131 153.636 76.1156 153.635 76.1179C153.633 76.1224 153.631 76.1252 153.629 76.1271C153.628 76.1289 153.624 76.1316 153.618 76.1341C153.611 76.1371 153.605 76.138 153.602 76.138V74.5V72.862C151.807 72.862 150.362 74.3202 150.362 76.1073H152ZM153.602 74.5V76.138C153.599 76.138 153.593 76.1371 153.586 76.1341C153.58 76.1316 153.576 76.1289 153.574 76.1271C153.573 76.1252 153.57 76.1224 153.569 76.1179C153.568 76.1156 153.567 76.1131 153.566 76.1107C153.566 76.1082 153.566 76.1069 153.566 76.1073H155.204H156.842C156.842 74.3202 155.396 72.862 153.602 72.862V74.5Z",
    fill: "currentColor",
    mask: "url(#path-5-inside-3_13398_258124)"
  })), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.053,
    cy: 30.6704,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.053,
    cy: 30.6704,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M160 30.6704H158.362C158.362 30.296 158.666 29.983 159.053 29.983V31.621V33.259C160.486 33.259 161.638 32.0949 161.638 30.6704H160ZM159.053 31.621V29.983C159.439 29.983 159.743 30.296 159.743 30.6704H158.105H156.467C156.467 32.0949 157.62 33.259 159.053 33.259V31.621ZM158.105 30.6704H159.743C159.743 31.0448 159.439 31.3577 159.053 31.3577V29.7197V28.0817C157.62 28.0817 156.467 29.2459 156.467 30.6704H158.105ZM159.053 29.7197V31.3577C158.666 31.3577 158.362 31.0448 158.362 30.6704H160H161.638C161.638 29.2459 160.486 28.0817 159.053 28.0817V29.7197Z",
    fill: "currentColor",
    mask: "url(#path-7-inside-4_13398_258124)"
  })), _mask16 || (_mask16 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.947465,
    cy: 19.1196,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.947465,
    cy: 19.1196,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89493 19.1196H0.256935C0.256935 18.7452 0.560907 18.4323 0.947465 18.4323V20.0703V21.7083C2.38056 21.7083 3.53293 20.5441 3.53293 19.1196H1.89493ZM0.947465 20.0703V18.4323C1.33402 18.4323 1.638 18.7452 1.638 19.1196H0H-1.638C-1.638 20.5441 -0.485634 21.7083 0.947465 21.7083V20.0703ZM0 19.1196H1.638C1.638 19.494 1.33402 19.8069 0.947465 19.8069V18.1689V16.531C-0.485634 16.531 -1.638 17.6951 -1.638 19.1196H0ZM0.947465 18.1689V19.8069C0.560907 19.8069 0.256935 19.494 0.256935 19.1196H1.89493H3.53293C3.53293 17.6951 2.38056 16.531 0.947465 16.531V18.1689Z",
    fill: "currentColor",
    mask: "url(#path-9-inside-5_13398_258124)"
  })), _mask17 || (_mask17 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-6_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9025,
    cy: 55.5434,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9025,
    cy: 55.5434,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.85 55.5434H21.212C21.212 55.169 21.516 54.8561 21.9025 54.8561V56.4941V58.1321C23.3356 58.1321 24.488 56.9679 24.488 55.5434H22.85ZM21.9025 56.4941V54.8561C22.2891 54.8561 22.5931 55.169 22.5931 55.5434H20.9551H19.3171C19.3171 56.9679 20.4694 58.1321 21.9025 58.1321V56.4941ZM20.9551 55.5434H22.5931C22.5931 55.9178 22.2891 56.2308 21.9025 56.2308V54.5928V52.9548C20.4694 52.9548 19.3171 54.119 19.3171 55.5434H20.9551ZM21.9025 54.5928V56.2308C21.516 56.2308 21.212 55.9178 21.212 55.5434H22.85H24.488C24.488 54.119 23.3356 52.9548 21.9025 52.9548V54.5928Z",
    fill: "currentColor",
    mask: "url(#path-11-inside-6_13398_258124)"
  })), _mask18 || (_mask18 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-7_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.188,
    cy: 34.8906,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.188,
    cy: 34.8906,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M132.135 34.8906H130.497C130.497 34.5162 130.801 34.2033 131.188 34.2033V35.8413V37.4792C132.621 37.4792 133.773 36.3151 133.773 34.8906H132.135ZM131.188 35.8413V34.2033C131.574 34.2033 131.878 34.5162 131.878 34.8906H130.24H128.602C128.602 36.3151 129.755 37.4792 131.188 37.4792V35.8413ZM130.24 34.8906H131.878C131.878 35.265 131.574 35.5779 131.188 35.5779V33.9399V32.3019C129.755 32.3019 128.602 33.4661 128.602 34.8906H130.24ZM131.188 33.9399V35.5779C130.801 35.5779 130.497 35.265 130.497 34.8906H132.135H133.773C133.773 33.4661 132.621 32.3019 131.188 32.3019V33.9399Z",
    fill: "currentColor",
    mask: "url(#path-13-inside-7_13398_258124)"
  })), _mask19 || (_mask19 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-8_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.947,
    cy: 16.4507,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.947,
    cy: 16.4507,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M104.895 16.4507H103.257C103.257 16.0762 103.561 15.7633 103.947 15.7633V17.4013V19.0393C105.381 19.0393 106.533 17.8751 106.533 16.4507H104.895ZM103.947 17.4013V15.7633C104.334 15.7633 104.638 16.0762 104.638 16.4507H103H101.362C101.362 17.8751 102.514 19.0393 103.947 19.0393V17.4013ZM103 16.4507H104.638C104.638 16.8251 104.334 17.138 103.947 17.138V15.5V13.862C102.514 13.862 101.362 15.0262 101.362 16.4507H103ZM103.947 15.5V17.138C103.561 17.138 103.257 16.8251 103.257 16.4507H104.895H106.533C106.533 15.0262 105.381 13.862 103.947 13.862V15.5Z",
    fill: "currentColor",
    mask: "url(#path-15-inside-8_13398_258124)"
  })), _mask20 || (_mask20 = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-9_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.1955,
    cy: 2.45066,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.1955,
    cy: 2.45066,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M35.143 2.45066H33.505C33.505 2.07625 33.809 1.76332 34.1955 1.76332V3.40131V5.03931C35.6286 5.03931 36.781 3.87513 36.781 2.45066H35.143ZM34.1955 3.40131V1.76332C34.5821 1.76332 34.886 2.07625 34.886 2.45066H33.248H31.6101C31.6101 3.87513 32.7624 5.03931 34.1955 5.03931V3.40131ZM33.248 2.45066H34.886C34.886 2.82507 34.5821 3.138 34.1955 3.138V1.5V-0.137995C32.7624 -0.137995 31.6101 1.02618 31.6101 2.45066H33.248ZM34.1955 1.5V3.138C33.809 3.138 33.505 2.82507 33.505 2.45066H35.143H36.781C36.781 1.02618 35.6286 -0.137995 34.1955 -0.137995V1.5Z",
    fill: "currentColor",
    mask: "url(#path-17-inside-9_13398_258124)"
  })), _mask21 || (_mask21 = /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-10_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26108,
    cy: 66.2455,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26108,
    cy: 66.2455,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86299 66.2455H2.22499C2.22499 66.2459 2.22497 66.2446 2.22548 66.2421C2.22597 66.2397 2.22674 66.2372 2.22773 66.2348C2.22962 66.2304 2.23179 66.2276 2.23362 66.2257C2.23544 66.2239 2.23883 66.2211 2.24471 66.2186C2.2517 66.2157 2.25833 66.2148 2.26108 66.2148V67.8528V69.4908C4.05562 69.4908 5.50098 68.0326 5.50098 66.2455H3.86299ZM2.26108 67.8528V66.2148C2.26384 66.2148 2.27047 66.2157 2.27746 66.2186C2.28333 66.2211 2.28672 66.2239 2.28855 66.2257C2.29038 66.2276 2.29255 66.2304 2.29443 66.2348C2.29542 66.2372 2.29619 66.2397 2.29668 66.2421C2.29719 66.2446 2.29717 66.2459 2.29717 66.2455H0.65918H-0.978815C-0.978815 68.0326 0.466547 69.4908 2.26108 69.4908V67.8528ZM0.65918 66.2455H2.29717C2.29717 66.2451 2.29719 66.2464 2.29668 66.2489C2.29619 66.2513 2.29542 66.2538 2.29443 66.2561C2.29255 66.2606 2.29038 66.2634 2.28855 66.2652C2.28672 66.2671 2.28333 66.2698 2.27746 66.2723C2.27047 66.2753 2.26384 66.2762 2.26108 66.2762V64.6382V63.0002C0.466547 63.0002 -0.978815 64.4584 -0.978815 66.2455H0.65918ZM2.26108 64.6382V66.2762C2.25833 66.2762 2.2517 66.2753 2.24471 66.2723C2.23883 66.2698 2.23544 66.2671 2.23362 66.2652C2.23179 66.2634 2.22962 66.2606 2.22773 66.2561C2.22674 66.2538 2.22597 66.2513 2.22548 66.2489C2.22497 66.2464 2.22499 66.2451 2.22499 66.2455H3.86299H5.50098C5.50098 64.4584 4.05562 63.0002 2.26108 63.0002V64.6382Z",
    fill: "currentColor",
    mask: "url(#path-19-inside-10_13398_258124)"
  })), _mask22 || (_mask22 = /*#__PURE__*/React.createElement("mask", {
    id: "path-21-inside-11_13398_258124",
    fill: "rgb(var(--color-bg-primary))"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.6019,
    cy: 61.1073,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.6019,
    cy: 61.1073,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2038 61.1073H44.5658C44.5658 61.1077 44.5658 61.1064 44.5663 61.1039C44.5668 61.1015 44.5676 61.099 44.5686 61.0967C44.5704 61.0922 44.5726 61.0894 44.5744 61.0875C44.5763 61.0857 44.5797 61.083 44.5855 61.0805C44.5925 61.0775 44.5991 61.0766 44.6019 61.0766V62.7146V64.3526C46.3964 64.3526 47.8418 62.8944 47.8418 61.1073H46.2038ZM44.6019 62.7146V61.0766C44.6047 61.0766 44.6113 61.0775 44.6183 61.0805C44.6242 61.083 44.6275 61.0857 44.6294 61.0875C44.6312 61.0894 44.6334 61.0922 44.6353 61.0967C44.6362 61.099 44.637 61.1015 44.6375 61.1039C44.638 61.1064 44.638 61.1077 44.638 61.1073H43H41.362C41.362 62.8944 42.8074 64.3526 44.6019 64.3526V62.7146ZM43 61.1073H44.638C44.638 61.1069 44.638 61.1082 44.6375 61.1107C44.637 61.1131 44.6362 61.1156 44.6353 61.1179C44.6334 61.1224 44.6312 61.1252 44.6294 61.1271C44.6275 61.1289 44.6242 61.1316 44.6183 61.1341C44.6113 61.1371 44.6047 61.138 44.6019 61.138V59.5V57.862C42.8074 57.862 41.362 59.3202 41.362 61.1073H43ZM44.6019 59.5V61.138C44.5991 61.138 44.5925 61.1371 44.5855 61.1341C44.5797 61.1316 44.5763 61.1289 44.5744 61.1271C44.5726 61.1252 44.5704 61.1224 44.5686 61.1179C44.5676 61.1156 44.5668 61.1131 44.5663 61.1107C44.5658 61.1082 44.5658 61.1069 44.5658 61.1073H46.2038H47.8418C47.8418 59.3202 46.3964 57.862 44.6019 57.862V59.5Z",
    fill: "currentColor",
    mask: "url(#path-21-inside-11_13398_258124)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.085 26.8813C24.7533 26.8813 26.1102 28.2387 26.1104 29.9194C26.1104 31.6003 24.7534 32.9585 23.085 32.9585C21.4165 32.9585 20.0596 31.6003 20.0596 29.9194C20.0597 28.2387 21.4166 26.8814 23.085 26.8813Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 1.638
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.426 59.6709C132.414 59.6711 133.22 60.4755 133.22 61.4736C133.22 62.4716 132.414 63.2762 131.426 63.2764C130.438 63.2764 129.632 62.4717 129.632 61.4736C129.632 60.4754 130.438 59.6709 131.426 59.6709Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 1.638
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4746 71.5208C100.752 71.5208 103.052 69.5236 103.052 64.7041C103.052 69.5236 105.337 71.5208 110.63 71.5208C105.337 71.5208 103.052 73.5759 103.052 78.3375C103.052 73.5759 100.752 71.5208 95.4746 71.5208Z",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9846 42.8697L77.7169 54.6478L68.6755 49.6164L72.6244 32.6526C73.7505 27.8152 77.2692 23.8193 82.038 21.9621L92.2179 17.9976C93.1621 17.6298 94.2136 18.215 94.3553 19.187L95.8831 29.6666C96.5988 34.5759 94.7677 39.511 90.9846 42.8697Z",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7598 56.1519C62.1497 60.5091 65.3654 65.2035 65.3654 65.2035C65.3654 65.2035 71.1911 65.5405 73.8011 61.1832",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1569 37.9251C59.9831 38.9693 59.2838 50.1995 59.2838 50.1995L68.6748 49.6158",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.955 47.273C92.6036 57.1221 82.8629 63.321 82.8629 63.321L78.6919 55.1901",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0262 39.0599C78.5294 37.6705 77.674 34.5934 79.1156 32.1869C80.557 29.7804 83.7495 28.9559 86.2463 30.3453C88.743 31.7347 89.5984 34.8118 88.1569 37.2182C86.7154 39.6248 83.523 40.4493 81.0262 39.0599Z",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0592 11.7306C53.622 11.6909 55.5938 9.82325 55.5519 5.35844C55.5938 9.82325 57.5864 11.6563 62.163 11.6164C57.5864 11.6563 55.629 13.5774 55.6703 17.9886C55.629 13.5774 53.622 11.6909 49.0592 11.7306Z",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }));
});
export default SvgIconRocket2;
export const raw = __webpack_public_path__ + "static/media/icon-rocket-2.268870078a5c9b8cbace3444b930ac1a.svg";